@if (headerOnTop) {
    <div class="grid-title sport">
        <ng-template *ngTemplateOutlet="iconTemplate || sportTitleHeader" />
    </div>
}
@if (showGroupContainer) {
    <div class="selector" [ngClass]="{ 'grid-six-pack-header': layout === layoutType.SixPack, 'grid-group-container': addGridGroupContainerClass }">
        @if (headerInRow) {
            <div class="grid-title" [class.title]="title">
                @if (!title) {
                    @if (!sortingVisible) {
                        <ng-template *ngTemplateOutlet="iconTemplate || sportTitleHeader" />
                    }
                } @else {
                    <span class="sport-name">{{ title }}</span>
                }
            </div>
        }
        <div class="sport-title-mobile">
            <ng-template *ngTemplateOutlet="sportTitleHeader" />
        </div>
        @if (sortingVisible && sorting !== undefined) {
            <ms-sort-selector
                class="grid-sort-selector sort-selector-web"
                [sorting]="sorting"
                [sortingTracking]="sortingTracking"
                [showRadioInput]="showRadioInputInSortSelector"
                [eventDetails]="eventDetails"
                (sortingChange)="sortingChanged($event)" />
        }
        @if (!hideMarketSwitcher && !showSwitcherBelowSubHeader) {
            <ng-template *ngTemplateOutlet="groupSelectorTemplate" />
        }
        @if (isSportHeaderCollapsed !== undefined) {
            <ng-container class="arrow-event-count">
                @if (isSportHeaderCollapsed) {
                    <div class="event-count">{{ eventsCount }}</div>
                }
                <span class="arrow">
                    @if (!isSportHeaderCollapsed) {
                        <vn-icon name="theme-up" size="14" />
                    } @else {
                        <vn-icon name="theme-down" size="14" />
                    }
                </span>
            </ng-container>
        }
    </div>

    @if (!hideMarketSwitcher && showSwitcherBelowSubHeader) {
        <div class="grid-dropdown-v2">
            <ng-template *ngTemplateOutlet="groupSelectorTemplate" />
        </div>
    }
}

<ng-template #sportTitleHeader>
    @if (!useColoredIcon) {
        <vn-icon class="sport-icon" [name]="'sports-' + sport.id" [size]="isEpcotEnabled ? '24' : '16'" />
    } @else {
        <div class="colored-icon">
            <ms-colored-icon [iconClass]="iconClass" />
        </div>
    }
    <span class="sport-name">{{ gridHeaderOverride ?? sport.name }}</span>
</ng-template>

<ng-template #groupSelectorTemplate>
    @for (column of columns; track column.id) {
        <ms-group-selector
            [column]="column"
            [columnCount]="columns.length"
            [contentClass]="contentClass"
            [offerBadgeTemplate]="offerBadgeTemplate"
            [tracking]="tracking"
            [popperAppendTo]="popperAppendTo"
            [positionEvent]="eventDetails"
            (groupChange)="groupChanged(column, $event)"
            (moreChange)="moreChanged($event)" />
    }
</ng-template>
